<template>
  <div
    class="absolute top-1/2 z-10 !flex -translate-y-1/2 cursor-pointer !items-center !justify-center before:!content-none"
    :class="{
      '!left-0': side === 'left',
      '!right-0': side === 'right',
      '!h-10 !w-8 lg:!h-16 lg:!w-12': !small,
      '!h-10 !w-8': small,
      collapse: areAllSlidesVisible,
    }"
    @click="() => (side === 'left' ? swiper.slidePrev() : swiper.slideNext())"
  >
    <IconArrowLeft
      class="text-black"
      :class="side !== 'left' && 'rotate-180'"
    />
  </div>
</template>

<script setup lang="ts">
defineProps({
  side: {
    type: String as PropType<'left' | 'right'>,
    required: true,
    validator: (val: string) => ['left', 'right'].includes(val),
  },
  small: {
    type: Boolean as PropType<boolean>,
    default: () => false,
  },
})
const swiper = useSwiper()
const areAllSlidesVisible = computed(
  () => swiper.value.isBeginning && swiper.value.isEnd,
)
</script>
